export const AGILITY_APP_TITLE = 'Agility';
